class Achievement {
  constructor(el,opt){
    this.el = el;
    if($("#" + this.el).length > 0){
      this.event();
    }
  }
  event() {
    let choice = {
      'ワンオンチャレンジ': ['お煎餅セット','スポーツブランドタオルセット','洗剤セット','入浴剤セット','メンズ・レディース軽量折りたたみ傘2本セット','洋菓子セット','和菓子セット','朝食のお供セット','調味料セット','ドリップ＆スティックコーヒーセット'],
      'ワンピンチャレンジ': ['サーロインステーキセット','オリジナル干物セット','肉餃子100個セット','国産牛ハンバーグセット','佐野ラーメン人気繁盛店セット','フランス産ワインセット','高級赤玉たまご50個'],
      'ホールインワンチャレンジ':['ビール1年分']
    }

    console.log(choice);

    if($('.mw_wp_form_input').length) {
      $('.js-form-item').css({'display': 'none'});
      $('.js-form-item option').wrap('<span></span>');

      if($('[name="challengeselect"]').val()) {
        el_change($('[name="challengeselect"]').val());
      }

      $('[name="challengeselect"]').change(function() {
        el_change($(this).val());
        // console.log($(this).val());
      })

      function el_change(el_val) {
        $('.js-form-item').css({'display': 'block'});
        $('.js-form-item select').val('');
        $('.js-form-item option').each(function(index,el) {
          // console.log(el);
          if($(el).parent()[0].localName != 'span') {
            $(el).wrap('<span></span>');
          }
        })
        choice[el_val].forEach(val => {
          $('.js-form-item option').each((index, el) => {
            if($(el).attr('value') === val) {
              $(el).unwrap();
            }
          });
        });
        $('.js-form-item select').val($('.js-form-item select > option').eq(0).val());
      }
    }
  }
}